module.exports = __webpack_public_path__ + "img/logo.c1f86b4f.png";